import { Navigate, useParams } from "react-router-dom";

import { ScopeFilter } from "../../components/insights/ScopeFilter";
import { WorkspaceTabs } from "../../components/ui/WorkspaceTabs";
import { t } from "../../lib/i18n";
import { NetworkAccessRequestsPage } from "../network/NetworkAccessRequestsPage";
import { ReportsIndexPage } from "../reports/ReportsIndexPage";
import { ViolationsWorkspace } from "./violations/ViolationsWorkspace";

const TAB_VALUES = [
  "violations",
  "reports",
  "access-requests",
] as const;
type InsightsTab = (typeof TAB_VALUES)[number];

export function InsightsWorkspace() {
  const { tab } = useParams<{ tab?: string }>();
  const active = (TAB_VALUES as readonly string[]).includes(tab ?? "")
    ? (tab as InsightsTab)
    : null;

  if (!active) {
    return <Navigate to="/insights/violations" replace />;
  }

  const tabs = TAB_VALUES.map((value) => ({
    value,
    label: t(`insights.tabs.${value}`),
  }));

  return (
    <div className="stack">
      <ScopeFilter />
      <WorkspaceTabs<InsightsTab>
        tabs={tabs}
        value={active}
        basePath="/insights"
        ariaLabel={t("insights.workspaceLabel")}
      />
      {active === "violations" && <ViolationsWorkspace />}
      {active === "reports" && <ReportsIndexPage />}
      {active === "access-requests" && <NetworkAccessRequestsPage />}
    </div>
  );
}
